<template>
  <div class="vertical-nav-menu-footer">
    <!-- User Profile Section -->
    <div class="d-flex align-items-center px-2 py-2 user-section">
      <div class="user-profile-section d-flex align-items-center">
        <div class="user-avatar">
          <b-avatar
            size="40"
            variant="warning"
            badge
            class="badge-minimal"
            badge-variant="success"
          >
            <feather-icon
              v-if="!userData || !userData.fullName"
              icon="UserIcon"
              size="22"
            />
            <span v-else class="avatar-content">{{ userData.fullName[0] }}</span>
          </b-avatar>
        </div>
        <div class="d-flex flex-column ml-1 user-info-wrapper">
          <div class="user-info mb-0">
            <p class="font-weight-bold mb-0">{{ userData ? userData.fullName : 'User Name' }}</p>
            <small class="text-muted">{{ userData ? userData.role : 'Status' }}</small>
          </div>
        </div>
      </div>
      
      <!-- Three Dots Menu with Dropdown -->
      <b-dropdown
        variant="link"
        no-caret
        right
        toggle-class="p-0 ml-auto menu-dots-dropdown"
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="21"
            class="align-middle text-body menu-dots-icon"
          />
        </template>
        <user-dropdown-items />
      </b-dropdown>
      
      <!-- Logout Button -->
      <b-link class="ml-2 logout-btn" @click="logout">
        <feather-icon
          icon="LogOutIcon"
          size="21"
          class="align-middle"
        />
      </b-link>
    </div>
  </div>
</template>

<script>
import { BLink, BDropdown, BAvatar } from 'bootstrap-vue'
import UserDropdownItems from '@core/layouts/components/app-navbar/components/UserDropdownItems.vue'
import { Auth, Hub } from 'aws-amplify'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BLink,
    BDropdown,
    BAvatar,
    UserDropdownItems
  },
  data() {
    return {
      userData: null,
    }
  },
  created() {
    this.userData = JSON.parse(localStorage.getItem('userData'))
  },
  methods: {
    async logout() {
      try {
        await Auth.signOut()

        this.$store.commit('auth/updateIdToken', undefined)
        this.$store.commit('auth/updateState', undefined)
        this.$store.commit('auth/updateUserDataKey', undefined)
        
        // Reset ability
        this.$ability.update(initialAbility)
        
        Hub.dispatch('UI Auth', {
          event: 'AuthStateChange',
          message: 'signedout',
        })
        
        try {
          await this.$store.dispatch('resetAllStore')
          localStorage.clear()
          await this.$router.push({ name: 'auth-login' })
        } catch (e) {
          console.log(e)
          await this.$router.push({ name: 'auth-login' })
        }
      } catch (error) {
        console.log('error signing out: ', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.vertical-nav-menu-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background-color: inherit !important;
  z-index: 10;
  max-height: 100px;
}

.user-profile-section {
  flex-grow: 1;
  overflow: hidden;
}

.user-section {
  background-color: inherit !important;
}

.menu-dots-dropdown {
  .menu-dots-icon {
    transition: opacity 0.15s ease;
    cursor: pointer;
    
    &:hover {
      opacity: 0.7;
    }
  }
}

.main-menu.menu-light .vertical-nav-menu-footer {
  background-color: inherit !important;
  
  .user-section {
    background-color: inherit !important;
  }
}

// Target expanded menu
.main-menu.expanded {
  .vertical-nav-menu-footer {
    .user-profile-section {
      display: flex !important;
    }
    
    .user-info-wrapper {
      display: flex !important;
    }
    
    .menu-dots-dropdown,
    .logout-btn {
      color: white !important;
      display: block;
    }
  }
}

// Target collapsed menu
.main-menu:not(.expanded) {
  .vertical-nav-menu-footer {
    .user-profile-section {
      width: 100%;
      justify-content: center;
    }
    
    .user-info-wrapper {
      display: none !important;
    }
    
    .user-section {
      justify-content: center;
      padding: 0.5rem !important;
    }
    
    .menu-dots-dropdown,
    .logout-btn {
      display: none !important;
    }
    
    .user-avatar {
      margin: 0 auto;
    }
  }
}

// Make sure all icons are aligned properly
.main-menu:not(.expanded) {
  .vertical-nav-menu-footer {
    .user-section {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// Dropdown menu tema uyumluluğu
.vertical-nav-menu-footer {
  .menu-dots-dropdown {
    :deep(.dropdown-menu) {
      background-color: rgba(14, 17, 27, 1) !important;
      border: 1px solid rgba(255, 255, 255, 0.1) !important;
      
      .dropdown-item {
        color: #d0d2d6 !important;
        
        &:hover,
        &:focus {
          background-color: rgba(255, 255, 255, 1) !important;
          color: #ffffff !important;
        }
        
        &:active {
          background-color: rgba(255, 255, 255, 1) !important;
          color: #ffffff !important;
        }
      }
      
      .dropdown-divider {
        border-color: rgba(255, 255, 255, 1) !important;
      }
    }
  }
}

// Menü açık durumdayken dropdown tema uyumluluğu
.main-menu.expanded {
  .vertical-nav-menu-footer {
    .menu-dots-dropdown {
      :deep(.dropdown-menu) {
        background-color: rgba(14, 17, 27, 1) !important;
        border: 1px solid rgba(255, 255, 255, 1) !important;
        
        .dropdown-item {
          color: #d0d2d6 !important;
          
          &:hover,
          &:focus {
            background-color: rgba(255, 255, 255, 1) !important;
            color: #ffffff !important;
          }
        }
      }
    }
  }
}
</style> 